<mat-sidenav-container>
  <mat-sidenav [opened]="isSidenavOpen" mode="side" role="navigation">
    <div class="mat-sidenav-wrapper">
      <div class="mat-nav-wrapper">
        <mat-nav-list>
          @for (item of navItems$ | async; track item) {
            <a [routerLink]="item.link" class="inactiveRow" routerLinkActive="activeRow"
              [attr.data-testid]="'side-menu-option-' + item.label.replaceAll(' ', '-').toLowerCase()">
              <div class="list-item" matRipple>
                <span class="list-item-icon" routerLinkActive="activeIcon"><mat-icon>{{ item.icon }}</mat-icon></span>
                <span class="list-item-label" routerLinkActive="activeText"
                  [matBadge]="badgeContent(item)"
                  matBadgeSize="small" matBadgeOverlap="false"
                  [matBadgeHidden]="isBadgeHidden(item)">
                  {{ (navLabelKeys[item.label] ?? item.label) | transloco }}
                </span>
              </div>
            </a>
          }
        </mat-nav-list>
        <mat-divider></mat-divider>
        <div mat-subheader class="section-subheader">{{ 'navigation.newRequest' | transloco }}</div>
        <mat-nav-list>
          @for (item of requestItems$ | async; track item) {
            <a [routerLink]="item.link" class="inactiveRow" routerLinkActive="activeRow"
              [attr.data-testid]="'side-menu-option-' + item.label.replaceAll(' ', '-').toLowerCase()">
              <div class="list-item" matRipple>
                <span class="list-item-icon" routerLinkActive="activeIcon"><mat-icon>{{ item.icon }}</mat-icon></span>
                <span class="list-item-label" routerLinkActive="activeText">{{ (navLabelKeys[item.label] ?? item.label) | transloco }}</span>
              </div>
            </a>
          }
        </mat-nav-list>
        <mat-divider></mat-divider>
        <div mat-subheader class="section-subheader">{{ 'navigation.help' | transloco }}</div>
        <mat-nav-list>
          @for (item of helpItems; track item) {
            <a [routerLink]="item.link" class="inactiveRow" routerLinkActive="activeRow"
              [attr.data-testid]="'side-menu-option-' + item.label.replaceAll(' ', '-').toLowerCase()">
              <div class="list-item" matRipple>
                <span class="list-item-icon" routerLinkActive="activeIcon"><mat-icon>{{ item.icon }}</mat-icon></span>
                <span class="list-item-label" routerLinkActive="activeText"
                  matBadge="{{ item.label === 'System Events' ? '!' : '' }}"
                  matBadgeSize="small" matBadgeOverlap="false"
                  [matBadgeHidden]="item.label === 'System Events' && activeEventsCount < 1">
                  {{ (navLabelKeys[item.label] ?? item.label) | transloco }}
                </span>
              </div>
            </a>
          }
        </mat-nav-list>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content #content>
    <div toastContainer aria-live="polite"></div>
    <div class="spacer-small"></div>
    <main id="main-content" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>